<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "clientDetail.documents.addNew" | translate }}</h2>
    </div>
    <button
      mat-icon-button
      type="button"
      (click)="cancel()"
      [disabled]="saving"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" class="document-add-form" (ngSubmit)="onSubmit()">
      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ "clientDetail.documents.file" | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <app-image-uploader
            [allowedFileExtensions]="allowedMimeTypes"
            [description]="dropDescription"
            [wrongTypeMessage]="wrongTypeMessage"
            (onFileChange)="fileChange($event)"
            (onFileRemove)="removeFile()"
          ></app-image-uploader>
          <input
            matInput
            formControlName="file"
            hidden="true"
            tabindex="-1"
            aria-hidden="true"
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-error *ngIf="form.hasError('required', ['file'])">{{ "fileRequired" | translate }}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ "clientDetail.documents.name" | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="name" type="text" [errorStateMatcher]="errorStateMatcher" />
          <mat-error *ngIf="form.hasError('required', ['name'])">{{ "fieldRequired" | translate }}</mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">
      {{ "cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="saving">
      <mat-spinner *ngIf="saving" diameter="20" class="dc-btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!saving">save</mat-icon>
      {{ saving ? ("saving" | translate) : ("save" | translate) }}
    </button>
  </footer>
</div>
